var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'compare-is-touch': _vm.isTouchDevice
    }
  }, [_c('div', {
    staticClass: "compare-container",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd
    }
  }, [_vm.showSliderButtons ? [!_vm.disableLeft ? _c('div', {
    staticClass: "compare-control compare-control_left",
    on: {
      "click": _vm.prev
    }
  }) : _vm._e(), _vm._v(" "), !_vm.disableRight ? _c('div', {
    staticClass: "compare-control compare-control_right",
    on: {
      "click": _vm.next
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compare-wrapper"
  }, [_c('div', {
    ref: "compareProductSlider",
    staticClass: "compare__top"
  }, [_c('div', {
    staticClass: "compare-actions"
  }, [_vm.listOrder && _vm.listOrder.length > 1 ? _c('Checkbox', {
    staticClass: "compare-actions__toggle-diff",
    model: {
      value: _vm.showOnlyDifferent,
      callback: function ($$v) {
        _vm.showOnlyDifferent = $$v;
      },
      expression: "showOnlyDifferent"
    }
  }, [_c('span', {
    staticClass: "compare-actions__toggle-diff-title compare-actions__toggle-diff-title_desktop"
  }, [_vm._v("Показать различия")]), _vm._v(" "), _c('span', {
    staticClass: "compare-actions__toggle-diff-title compare-actions__toggle-diff-title_mobile"
  }, [_vm._v("Только различающиеся характеристики")])]) : _vm._e(), _vm._v(" "), _vm.path ? _c('nuxt-link', {
    staticClass: "compare-actions__item link link_grey link_wu",
    attrs: {
      "to": _vm.path
    }
  }, [_c('div', {
    staticClass: "compare-actions__icon-add"
  }), _vm._v("\n            Добавить товары\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compare-actions__item compare-actions__item_clear link link_grey link_wu",
    on: {
      "click": function ($event) {
        return _vm.emit('delete-category');
      }
    }
  }, [_c('div', {
    staticClass: "compare-actions__icon-remove"
  }), _vm._v("\n            Очистить категорию\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "compare-product-list"
  }, [_c('div', {
    staticClass: "compare-product-slider"
  }, [_c('div', {
    ref: "row",
    staticClass: "compare-row"
  }, [_c('div', {
    staticClass: "compare-slider-row",
    style: ("transform: translateX(" + (_vm.needSlidePx) + "px)")
  }, _vm._l(_vm.listOrder, function (productIndex, index) {
    var _vm$_b;

    return _c('div', {
      key: _vm.products[productIndex].id,
      ref: "cardRef",
      refInFor: true,
      staticClass: "compare-product-image compare-slider_col compare-product",
      on: {
        "mouseover": function ($event) {
          return _vm.handleDragOver({
            index: productIndex
          });
        }
      }
    }, [_c('TSProductCard', _vm._b({
      staticClass: "product-card_adaptive",
      attrs: {
        "product": _vm.products[productIndex],
        "data-e2e": "product-card",
        "data-e2e-product-card-id": _vm.products[productIndex].id,
        "photo-lazyload": "",
        "source": "Сравнение",
        "hide": ['mobile-border', 'mobile-more', 'desktop-tools', 'bonus', 'mobile-favorite']
      },
      on: {
        "remove-favorite": function ($event) {
          return _vm.emit('remove-favorite', $event);
        },
        "product-select": function ($event) {
          return _vm.emit('product-select', {
            index: index,
            product: _vm.products[productIndex]
          });
        },
        "add-product": function ($event) {
          return _vm.emit('add-product', _vm.products[productIndex]);
        },
        "mouseover": function ($event) {
          return _vm.handleDragOver({
            index: productIndex
          });
        }
      }
    }, 'TSProductCard', (_vm$_b = {}, _vm$_b[("data-e2e-product-card-" + (_vm.products[productIndex].id))] = _vm.products[productIndex].id, _vm$_b), false)), _vm._v(" "), _c('div', {
      staticClass: "compare-product-image_controls"
    }, [_vm.isTouchDevice() !== null && !_vm.isTouchDevice() ? _c('button', {
      staticClass: "move-button",
      on: {
        "mousedown": function ($event) {
          return _vm.handleDragStart({
            event: $event,
            index: productIndex
          });
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('ActionFavorite', {
      attrs: {
        "id": _vm.products[productIndex].id,
        "product": _vm.products[productIndex],
        "list-name": "Сравнение"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref) {
          var addFavorite = _ref.add,
              removeFavorite = _ref.remove,
              activeFavorite = _ref.active,
              loading = _ref.loading;
          return [_c('UserTool', {
            staticClass: "favorite-button",
            attrs: {
              "type": "favorite",
              "active": activeFavorite,
              "loading": loading
            },
            on: {
              "add": addFavorite,
              "remove": removeFavorite
            }
          })];
        }
      }], null, true)
    }), _vm._v(" "), _c('ActionCompare', {
      attrs: {
        "id": _vm.products[productIndex].id
      },
      on: {
        "success": function ($event) {
          return _vm.handleDeleteProduct({
            index: index
          });
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref2) {
          var remove = _ref2.remove;
          return [_c('button', {
            staticClass: "delete-button",
            on: {
              "click": remove
            }
          })];
        }
      }], null, true)
    })], 1)], 1);
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-row"
  }, [_c('div', {
    staticClass: "compare-row__property compare-row__property_without-border"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "compare-slider-row",
    style: ("transform: translateX(" + (_vm.needSlidePx) + "px)")
  }, _vm._l(_vm.listOrder, function (productIndex) {
    var _vm$products$productI, _vm$products$productI2;

    return _c('div', {
      key: productIndex,
      staticClass: "compare-slider_col"
    }, [(_vm$products$productI = _vm.products[productIndex].price) !== null && _vm$products$productI !== void 0 && _vm$products$productI.bonus ? _c('TSBonusCount', {
      attrs: {
        "count": ((_vm$products$productI2 = _vm.products[productIndex].price) === null || _vm$products$productI2 === void 0 ? void 0 : _vm$products$productI2.bonus) || 0
      }
    }) : _c('span', [_vm._v("-")])], 1);
  }), 0)])]), _vm._v(" "), _vm._l(_vm.properties, function (property, i) {
    return _c('div', {
      key: i,
      staticClass: "compare-row",
      class: [_vm.showOnlyDifferent ? 'compare-row_only-diff' : '']
    }, [_c('Toggle', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref3) {
          var onClick = _ref3.onClick,
              isActive = _ref3.isActive;
          return [property.name ? _c('h5', {
            staticClass: "compare-property_type",
            on: {
              "click": onClick
            }
          }, [_vm._v("\n              " + _vm._s(property.name) + "\n              "), _c('div', {
            staticClass: "compare-property__icon-needle",
            class: [{
              'compare-property__icon-needle_rotate': isActive
            }]
          })]) : _vm._e(), _vm._v(" "), !isActive ? _vm._l(property.characteristic, function (char, index) {
            return _c('div', {
              key: index,
              staticClass: "compare-row__property",
              class: [!_vm.isDifferentProperties(char) ? 'compare-row__property_eq' : null]
            }, [_c('div', {
              staticClass: "compare-property_name-block"
            }, [_c('h6', {
              staticClass: "compare-property_name"
            }, [_vm._v("\n                    " + _vm._s(char === null || char === void 0 ? void 0 : char.name) + "\n                  ")])]), _vm._v(" "), char.specification ? _c('div', {
              staticClass: "compare-slider-row",
              style: ("transform: translateX(" + (_vm.needSlidePx) + "px)")
            }, _vm._l(_vm.listOrder, function (productIndex) {
              return _c('div', {
                key: productIndex,
                staticClass: "compare-slider_col"
              }, [_vm._v("\n                    " + _vm._s(char.specification[productIndex].value ? char.specification[productIndex].value : '–') + "\n                  ")]);
            }), 0) : _vm._e()]);
          }) : _vm._e()];
        }
      }], null, true)
    })], 1);
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOverlayProductSlider,
      expression: "isOverlayProductSlider"
    }],
    staticClass: "compare-slider-overlay"
  }), _vm._v(" "), _vm.isSticky ? _c('div', {
    staticClass: "compare-top-sticky"
  }, [_c('div', {
    staticClass: "compare-top-sticky__wrapper"
  }, [_c('div', {
    staticClass: "compare-top-sticky__action"
  }, [_vm.listOrder && _vm.listOrder.length > 1 ? _c('Checkbox', {
    staticClass: "compare-actions__toggle-diff",
    model: {
      value: _vm.showOnlyDifferent,
      callback: function ($$v) {
        _vm.showOnlyDifferent = $$v;
      },
      expression: "showOnlyDifferent"
    }
  }, [_c('span', {
    staticClass: "compare-actions__toggle-diff-title"
  }, [_vm._v("Показать различия")])]) : _vm._e(), _vm._v(" "), _vm.path ? _c('nuxt-link', {
    staticClass: "compare-actions__item link link_grey link_wu",
    attrs: {
      "to": _vm.path
    }
  }, [_c('div', {
    staticClass: "compare-actions__icon-add"
  }), _vm._v("\n            Добавить товары\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compare-actions__item compare-actions__item_clear link link_grey link_wu",
    on: {
      "click": function ($event) {
        return _vm.emit('delete-category');
      }
    }
  }, [_c('div', {
    staticClass: "compare-actions__icon-remove"
  }), _vm._v("\n            Очистить категорию\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "compare-top-sticky__product-slider"
  }, [_vm.showSliderButtons ? [!_vm.disableLeft ? _c('div', {
    staticClass: "compare-control compare-control_left",
    on: {
      "click": _vm.prev
    }
  }) : _vm._e(), _vm._v(" "), !_vm.disableRight ? _c('div', {
    staticClass: "compare-control compare-control_right",
    on: {
      "click": _vm.next
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compare-product-list"
  }, [_c('div', {
    staticClass: "compare-product-slider"
  }, [_c('div', {
    ref: "row",
    staticClass: "compare-row"
  }, [_c('div', {
    staticClass: "compare-slider-row",
    style: ("transform: translateX(" + (_vm.needSlidePx) + "px)")
  }, _vm._l(_vm.listOrder, function (productIndex, index) {
    var _vm$_b2;

    return _c('div', {
      key: _vm.products[productIndex].id,
      ref: "cardRef",
      refInFor: true,
      staticClass: "compare-product-image compare-slider_col compare-product",
      on: {
        "mouseover": function ($event) {
          return _vm.handleDragOver({
            index: productIndex
          });
        }
      }
    }, [_c('CompareProductCard', _vm._b({
      attrs: {
        "data": _vm.products[productIndex],
        "data-e2e": "product-card",
        "data-e2e-product-card-id": _vm.products[productIndex].id
      },
      on: {
        "add-product": function ($event) {
          return _vm.emit('add-product', _vm.products[productIndex]);
        },
        "product-select": function ($event) {
          return _vm.emit('product-select', {
            index: index,
            product: _vm.products[productIndex]
          });
        }
      }
    }, 'CompareProductCard', (_vm$_b2 = {}, _vm$_b2[("data-e2e-product-card-" + (_vm.products[productIndex].id))] = _vm.products[productIndex].id, _vm$_b2), false))], 1);
  }), 0)])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOverlayProductSlider,
      expression: "isOverlayProductSlider"
    }],
    staticClass: "compare-slider-overlay"
  })])]) : _vm._e()], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "compare-property_name-block"
  }, [_c('h6', {
    staticClass: "compare-property_name"
  }, [_vm._v("\n              Бонусы\n            ")])]);
}]

export { render, staticRenderFns }